import React from 'react'
import {
    ToDateJalali,
} from "../../../Common/Function";
function Index({ data }) {
    const Handleritemtype = (data) => {
        switch (data) {
            case 'pool':
                return 'استخر'
                break;
            case 'gym':
                return 'باشگاه'
                break;
            case 'saloon':
                return 'سالن'
                break;

        }
    };
    const Handlercontracttype = (data) => {
        switch (data.contracttype) {
            case 'btwobb':
                return (
                    <>
                        <p>
                            طبق قوانین شرکت مبلغ B2B اعلام شده توسط مدیراستخر به حساب اعلام شده در ماده 4 واریز می شود.
                        </p>
                        <div className='d-flex'>
                            <span style={{ marginRight: '20px' }}>
                                نرخ خرید نیکوتن از شما  :
                            </span>
                            <span style={{ marginRight: '5px' }}>
                                {data.netprice} تومان
                            </span>
                            <span style={{ marginRight: '20px' }}>
                                نرخ فروش نیکوتن به کاربران  :
                            </span>
                            <span style={{ marginRight: '5px' }}>
                                {data.bordprice} تومان
                            </span>
                        </div>
                    </>
                );
                break;
            case 'perecentage':
                return <p > مبلغ همکاری در فروش رزرو ها طبق قوانین شرکت  {data.perecentage} درصد از مبلغ هر رزرو می باشد.</p>
                break;

        }
    };
    const handletstaus = (data) => {
        let result = {
            text: "",
            style: {}
        }
        switch (data.register) {
            case 'done':
                result = {
                    text: 'قرارداد شما تایید شده است',
                    style: { backgroundColor: "rgb(30, 140, 59)", color: '#ffff' }
                }
                break;
            case 'wait':
                result = {
                    text: 'قرارداد در انتظار تایید است لطفا منتظر بمانید',
                    style: { backgroundColor: "#F0F0F0" }
                }
                break;
            case 'reject':
                result = {
                    text: 'قرارداد رد شده است ',
                    style: { backgroundColor: "rgb(228, 42, 63)", color: '#ffff' }
                }
                break;
        }
        return result;
    }
    return (
        <div className='contract-modal'>
            <div>
                <div className="d-flex justify-content-center align-item-center">
                    <div
                        className="card  text-center shadow"
                        style={{
                            padding: "20px 30px",
                            width: "100%",
                            ...handletstaus(data.data)['style']
                        }}
                    >
                        <div className='' style={{ ...handletstaus(data.data)['style'] }}>
                            <h3>{handletstaus(data.data)['text']}</h3>
                            {data.data.register == 'done' ? (
                                <span>شماره قراداد : {data.data.registore_code}</span>
                            ) : (
                                <span>پشتیبانی : 02191027127</span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className='d-flex justify-content-center align-items-center text-center'>
                <h4>قرارداد همکاری در فروش نیکوتن</h4>
            </div>
            <div className="input-box row mt-2">
                <div className="col d-flex boxinp align-items-center">
                    <span style={{ whiteSpace: 'nowrap' }}>این قرارداد فی ما بین : </span>
                    <span style={{ marginRight: '5px', whiteSpace: 'nowrap' }}>
                        {data.data.itemname}
                    </span>
                </div>
                <div className="col d-flex boxinp  align-items-center">
                    <span style={{ whiteSpace: 'nowrap' }} > به آدرس : </span>
                    <span style={{ marginRight: '5px', whiteSpace: 'nowrap' }}>
                        {data.data.itemaddres}
                    </span>
                </div>
                <div className="col d-flex boxinp  align-items-center">
                    <span style={{ whiteSpace: 'nowrap' }}> به نمایندگی:</span>
                    <span style={{ marginRight: '5px', whiteSpace: 'nowrap' }}>
                        {data.data.managername}
                    </span>
                </div>
                <div className="col d-flex boxinp  align-items-center">
                    <span style={{ whiteSpace: 'nowrap' }}> کد ملی :</span>
                    <span style={{ marginRight: '5px', whiteSpace: 'nowrap' }}>
                        {data.data.managerntinalcode}
                    </span>
                </div>
                <div className="col d-flex boxinp  align-items-center">
                    <span style={{ whiteSpace: 'nowrap' }} > شماره همراه :</span>
                    <span style={{ marginRight: '5px', whiteSpace: 'nowrap' }}>
                        {data.data.managermobile}
                    </span>
                </div>
            </div>
            <div className="mt-3 textfotter">
                <p>
                    که از این به بعد کارفرما نامیده می شود از یک طرف و شرکت ویداسیستم ایرانیان<span><a style={{ marginRight: '5px', marginLeft: '5px' }} href='http://nikotan.ir'>(سامانه ورزشی نیکوتن) </a></span> به نمایندگی آقای سعید شوروزی به آدرس بلوار پژوهش، پارک علم و فناوری خراسان – مرکز رشد شهرستان نیشابور که از این پس کارشناس نامیده می شود از طرف دیگر منعقد می گردد:
                </p>
            </div>



            <div className="row mt-4">
                <div className="col-12">
                    <h6>1-	موضوع همکاری:</h6>
                    <div style={{ marginBottom: "10px" }}>
                        <p>
                            همکاری در رزرو {Handleritemtype(data.data.itemtype)} {data.data.itemname}
                        </p>
                    </div>
                </div>
                <div className="col-12">
                    <h6> 2-	مدت قرارداد:</h6>
                    <div style={{ marginBottom: "10px" }}>
                        <p>
                            از تاریخ {ToDateJalali(data.data.dateofconteact)} به مدت یکسال شمسی می باشد
                        </p>
                    </div>
                </div>
                <div className="col-12">
                    <h6>3-	مبلغ قرارداد:</h6>
                    <div style={{ marginBottom: "10px" }}>
                        {Handlercontracttype(data.data)}
                    </div>
                </div>
                <div className="col-12">
                    <h6> 4-	نحوه پرداخت:</h6>
                    <div style={{ marginBottom: "10px" }}>
                        <p>
                            پس از ثبت درخواست و کسر مبالغ قرارداد طبق بند 3 در کمتر از سه روز کاری به حساب مشخص شده در بانک {data.data.bankname} به شماره شبا {data.data.bankshaba}و به نام {data.data.managername} واریز می شود.
                        </p>
                    </div>
                </div>
                <div className="col-12">
                    <h6>5-	تعهدات کارشناس:</h6>
                    <div style={{ marginBottom: "10px" }}>
                        <p>
                            5-1. کارشناس متعهد می گردد تمامی اطلاعات مجموعه های ورزشی و رزروها به صورت محرمانه باقی بماند.
                        </p>
                        <p>
                            5-2. کارشناس متعهد می گردد اطلاعات کامل افراد ثبت نام کننده را به کارفرما تحویل دهد.
                        </p>
                    </div>
                </div>
                <div className="col-12">
                    <h6>  6-	تعهدات کارفرما:</h6>
                    <div style={{ marginBottom: "10px" }}>
                        <p>
                            1_6. ارسال درخواست کتبی در صورت نیاز به اعزام کارشناس
                        </p>
                        <p>
                            2_6. کارفرما متعهد می شود مستندات و داده های مورد نیاز کارشناس را طی دو روز کاری برای کارشناس و یا نماینده کارشناس ارسال کند.
                        </p>
                        <p>
                            3_6. کارفرما متعهد می شود تمامی اطلاعات مجموعه ورزشی را در اختیار کارشناس قرار دهد.
                        </p>
                        <p>
                            4_6. کارفرما متعهد می شود رزروهای سایت برای سانس های مجموعه ورزشی در اولویت باشد.
                        </p>
                        <p>
                            6-5. کارفرما متعهد می شود رزروهایی که از طریق سامانه انجام شده است در اولویت باشند.
                        </p>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Index